import { __extends } from "tslib";
import { OpCodes } from './OpCodes';
import { GLESAssetBase } from './GLESAssetBase';
import { GLESConnector } from './GLESConnector';
import { Byte32Array } from '@awayjs/core';
var VertexBufferGLES = /** @class */ (function (_super) {
    __extends(VertexBufferGLES, _super);
    function VertexBufferGLES(context, gl, numVertices, dataPerVertex, id) {
        var _this = _super.call(this, context, id) || this;
        // this._gl = gl;
        // this._buffer = this._gl.createBuffer();
        _this._numVertices = numVertices;
        _this._dataPerVertex = dataPerVertex;
        return _this;
    }
    VertexBufferGLES.prototype.uploadFromArray = function (array, startVertex, numVertices) {
        //GLESConnector.gles.uploadVertexDataFromArray(this.id, vertices, startVertex, numVertices);
        // this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._buffer);
        //
        // if (startVertex)
        // 	this._gl.bufferSubData(this._gl.ARRAY_BUFFER, startVertex*this._dataPerVertex, new Float32Array(vertices));
        // else
        // 	this._gl.bufferData(this._gl.ARRAY_BUFFER, new Float32Array(vertices), this._gl.STATIC_DRAW);
    };
    VertexBufferGLES.prototype.uploadFromByteArray = function (data, startVertex, numVertices) {
        var newSendbytes = new Byte32Array();
        newSendbytes.writeInt(1); //send create bytes
        newSendbytes.writeInt(OpCodes.uploadArrayVertexBuffer);
        newSendbytes.writeInt(this.id);
        newSendbytes.writeInt(startVertex);
        newSendbytes.writeInt(data.byteLength);
        newSendbytes.writeInt32Array(new Int32Array(data)); //TODO: cache the view on the attributebuffer
        newSendbytes.bytePosition = 0;
        var localInt32View = new Int32Array(newSendbytes.byteLength / 4);
        newSendbytes.readInt32Array(localInt32View);
        GLESConnector.gles.sendGLESCommands(localInt32View.buffer);
    };
    Object.defineProperty(VertexBufferGLES.prototype, "numVertices", {
        get: function () {
            return this._numVertices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VertexBufferGLES.prototype, "dataPerVertex", {
        get: function () {
            return this._dataPerVertex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VertexBufferGLES.prototype, "glBuffer", {
        get: function () {
            return this._buffer;
        },
        enumerable: false,
        configurable: true
    });
    VertexBufferGLES.prototype.dispose = function () {
        //console.log("dispose vertexdata "+this.id);
        //this._context.addCreateStream(String.fromCharCode(OpCodes.disposeVertexBuffer) + this.id+"#END");
        this._context._createBytes.writeInt(OpCodes.disposeVertexBuffer);
        this._context._createBytes.writeInt(this.id);
    };
    return VertexBufferGLES;
}(GLESAssetBase));
export { VertexBufferGLES };
